import {
  AbstractControl,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from "@angular/forms";

/**
 * Parses a string array of validator definitions and returns Angular ValidatorFns.
 * Supports: Required, MinLength, MaxLength, Min, Max, DateMin, DateMax.
 */
export function parseValidators(validators?: string[]): ValidatorFn[] {
  if (!validators || validators.length === 0) return [];
  const result: ValidatorFn[] = [];

  for (const v of validators) {
    const [name, param] = v.split(":");
    switch (name.trim().toLowerCase()) {
      case "required":
        result.push(Validators.required);
        break;
      case "minlength":
        if (param) result.push(Validators.minLength(Number(param)));
        break;
      case "maxlength":
        if (param) result.push(Validators.maxLength(Number(param)));
        break;
      case "min":
        if (param) result.push(Validators.min(Number(param)));
        break;
      case "max":
        if (param) result.push(Validators.max(Number(param)));
        break;
      case "datemin":
        if (param) result.push(dateMinValidator(param));
        break;
      case "datemax":
        if (param) result.push(dateMaxValidator(param));
        break;
      case "minitems":
        if (param) result.push(Validators.minLength(Number(param)));
        break;
      case "maxitems":
        if (param) result.push(Validators.maxLength(Number(param)));
        break;
      default:
        console.warn(`Unknown validator: ${name}`);
        break;
      // Add more cases here as needed
    }
  }
  return result;
}

/**
 * Custom validator: control value must be >= minDate (ISO string)
 */
function dateMinValidator(minDate: string): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) return null;
    const valueDate = new Date(control.value);
    const min = new Date(minDate);
    if (isNaN(valueDate.getTime()) || isNaN(min.getTime())) return null;
    return valueDate >= min
      ? null
      : { dateMin: { required: minDate, actual: control.value } };
  };
}

/**
 * Custom validator: control value must be <= maxDate (ISO string)
 */
function dateMaxValidator(maxDate: string): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) return null;
    const valueDate = new Date(control.value);
    const max = new Date(maxDate);
    if (isNaN(valueDate.getTime()) || isNaN(max.getTime())) return null;
    return valueDate <= max
      ? null
      : { dateMax: { required: maxDate, actual: control.value } };
  };
}
